import Vue from 'vue'
import VueRouter from 'vue-router'
import { getPicUrl, setPicUrl } from '@/utils/auth'
import { getUrl } from '@/api/index'

Vue.use(VueRouter)

const routes = [{
        path: '/businessId/:businessId',
        name: 'Home',
        meta: {
            title: '首页',
            deepth: 0.5,
            keepAlive: true //需要被缓存的
        },
        component: () => import ( /* webpackChunkName: "about" */ '../views/Home.vue')
    },
    {
        path: '/scenicDetail/businessId/:businessId/scenicId/:scenicId',
        name: 'ScenicDetail',
        meta: {
            title: '景区详情',
            deepth: 1
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/ScenicDetail.vue')
    },
    {
        path: '/orderFrom/businessId/:businessId',
        name: 'OrderFrom',
        meta: {
            title: '绑定手机号',
            deepth: 2
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/OrderFrom.vue')
    },
    {
        path: '/order/businessId/:businessId',
        name: 'Order',
        meta: {
            title: '预约',
            deepth: 0.5
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Order.vue')
    },
    {
        path: '/orderDetail/businessId/:businessId/orderId/:orderId',
        name: 'OrderDetail',
        meta: {
            title: '预约详情',
            deepth: 1
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/OrderDetail.vue')
    },
    {
        path: '/scenicList',
        name: 'ScenicList',
        meta: {
            title: '景区列表',
            deepth: 0.5
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/ScenicList.vue')
    },
    {
        path: '*',
        name: 'Error',
        meta: {
            title: '404.',
            deepth: 99
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../components/Error.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async(to, from, next) => {
    const defaultTitle = '中青文旅畅游卡'
    document.title = to.meta.title ? to.meta.title : defaultTitle
		console.log(7)
        setPicUrl('')
    if(!getPicUrl()) {
			try {
				await getUrl({}).then(function (res) {
					if(res.data.code != '200'){
						setPicUrl('')
						throw res.data.msg
					}
					if(res.data.code == '200'){
							setPicUrl(res.data.data)
							next()
					}
				})
			} catch (error) {
				console.log(error)
			}
    }
		next()
})

export default router